import { useMemo } from 'react';
import useInspireOptions from '../../../hooks/useInspireOptions';
import { Profile } from '../../../Types';

/*
   only show the summaries container if the displayed profile is:
   - the logged in user
   - their manager
   - a proxy of their manager
   shared profiles do not have access to summaries.
  */
const useHasPermissionToViewSummaries = (
  displayProfile: Profile,
  loggedInProfile: Profile
) => {
  const { requesterUsername, isAdmin } = useInspireOptions();

  return useMemo(() => {
    if (isAdmin) return true;

    const isRequestorSame = requesterUsername === displayProfile.user.alias;
    if (isRequestorSame) return true;

    const isRequestorManager = displayProfile.managers.some(
      manager => manager.alias === requesterUsername
    );
    if (isRequestorManager) return true;

    const isRequestorProxyManager = loggedInProfile.proxyCoaches.some(
      proxy => proxy.tmEntity.alias === requesterUsername // for each of the managers of the profile we're viewing, does the loggedIn user have them as a proxyCoachee
    );

    if (isRequestorProxyManager) return true;
    return false;
  }, [
    displayProfile.managers,
    displayProfile.user.alias,
    loggedInProfile.proxyCoaches,
    requesterUsername,
    isAdmin,
  ]);
};

export default useHasPermissionToViewSummaries;
